import React, {useState} from "react";
import ImageComponent from "../../../utilities/ImageComponent";
import ClickableLink from "../../../utilities/ClickableLink";
import styles from "./styles/ShopItem.module.scss"
import classNames from "classnames";

interface ShopItem {
    title: string,
    image: string,
    url: string,
    price: string,
}

const ProductImage = (props:{
    imageUrl: string,
    scale: number }) => {
    const [transform, setTransform] = useState('scale(1)');
    const [transformOrigin, setTransformOrigin] = useState('50% 50%');

    const handleMouseOver = () => {
        setTransform(`scale(${props.scale})`);
    };

    const handleMouseOut = () => {
        setTransform('scale(1)');
    };

    const handleMouseMove = (e) => {
        const rect = e.target.getBoundingClientRect();
        const offsetX = ((e.clientX - rect.left) / rect.width) * 100;
        const offsetY = ((e.clientY - rect.top) / rect.height) * 100;
        setTransformOrigin(`${offsetX}% ${offsetY}%`);
    };

    return (
        <div
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            onMouseMove={handleMouseMove}
            data-scale={props.scale}
        >
            <ImageComponent
                src={props.imageUrl}
                style={{
                    transform: transform,
                    transformOrigin: transformOrigin,
                }}
            ></ImageComponent>
        </div>
    );
};

const ShopItem = (props: {
    item: ShopItem
    className?: string,
}) => {

    const shopItemClassName = classNames({
        [styles.item]: true,
        [props.className || '']: props.className,
    });

    return (
        <div className={shopItemClassName}>
            <ProductImage imageUrl={props.item.image} scale={1.4}/>
            <div className={styles.itemInfo}>
                <ClickableLink href={props.item.url}>Buy Now</ClickableLink>
            </div>
        </div>
    )
}

export default ShopItem;

